import { and, ControlProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { Unwrapped } from '@jsonforms/material-renderers'
import { withJsonFormsControlProps } from '@jsonforms/react'
import ExpandLessOutlined from '@material-ui/icons/ExpandLessOutlined'
import ExpandMoreOutlined from '@material-ui/icons/ExpandMoreOutlined'
import { Checkbox, FormControlLabel } from 'opensolar-ui'
import React, { useState } from 'react'
import { makeOpenSolarStyles } from 'themes/makeOpenSolarStyles'

const { MaterialBooleanControl } = Unwrapped

const tester = rankWith(100, and(uiTypeIs('ExpandableTerms')))

const useStyles = makeOpenSolarStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  icon: {
    cursor: 'pointer',
  },
  readMoreRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
  },
  readMore: {
    cursor: 'pointer',
    fontSize: '12px',
    color: '#a2a2a2',
    textDecoration: 'underline',
  },
}))

const Renderer: React.FC<ControlProps> = (props) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const [isChecked, setIsChecked] = useState<boolean>(false)
  const classes = useStyles()

  // @ts-ignore
  const termsName = props.schema?.properties?.ExpandableTerms?.name
  // @ts-ignore
  const termsLabel = props.schema?.properties?.ExpandableTerms?.label || `I agree to the ${termsName}`

  // When props.data is set give priority to that, otherwise use local state
  const checkedValue = props.data ?? isChecked

  return (
    <div>
      <div className={classes.row}>
        <FormControlLabel
          control={
            <Checkbox
              {...props}
              onChange={(e) => {
                setIsChecked(e.target.checked)
                props.handleChange(props.path, e.target.checked)
              }}
              checked={checkedValue}
            />
          }
          label={termsLabel}
        />

        {isExpanded ? (
          <ExpandLessOutlined className={classes.icon} onClick={() => setIsExpanded(false)} />
        ) : (
          <ExpandMoreOutlined className={classes.icon} onClick={() => setIsExpanded(!isExpanded)} />
        )}
      </div>
      {isExpanded ? (
        // @ts-ignore
        <>
          {/* @ts-ignore */}
          {props?.schema?.properties?.ExpandableTerms?.html ? (
            // @ts-ignore
            <div
              className="small"
              // @ts-ignore
              dangerouslySetInnerHTML={{ __html: props.schema?.properties?.ExpandableTerms?.html }}
            />
          ) : (
            // @ts-ignore
            <div className="small">{props.schema?.properties?.ExpandableTerms?.text}</div>
          )}
        </>
      ) : (
        <div className={classes.readMoreRow}>
          {/* @ts-ignore */}
          {props?.schema?.properties?.ExpandableTerms?.text ? (
            // @ts-ignore
            <div className="small">{props.schema?.properties?.ExpandableTerms?.text.substring(0, 80)}</div>
          ) : (
            <div className="small">...</div>
          )}
          {/* @ts-ignore */}

          <div>
            ...{' '}
            <a className={classes.readMore} onClick={() => setIsExpanded(true)}>
              Read more
            </a>
          </div>
        </div>
      )}
    </div>
  )
}

const renderer = withJsonFormsControlProps(Renderer)

export default {
  tester,
  renderer,
}
